import * as React from 'react';

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className = '', ...props }, ref) => {
    return (
      <textarea
        className={`shadcn-textarea ${className}`.trim()}
        ref={ref}
        {...props}
      />
    );
  }
);
Textarea.displayName = 'Textarea';
